/**
 * M List hero / intro section. Twentytwentysix design language.
 */
import React from "react";
import { Link } from "react-router-dom";

export default function MListHeroIntroSection() {
  return (
    <>
      <p className="twentytwentysix-content__eyebrow">The Mamahood</p>
      <h1 className="twentytwentysix-content__title">The M List</h1>
      <p className="twentytwentysix-content__copy">
        Our list of local resources vetted and vouched for by The Mamahood. Every listing wears the M List seal. Browse by category or search for what you need.
      </p>
      <div className="twentytwentysix-content__cta-row">
        <Link to="/twentytwentysix" className="twentytwentysix-content__pill">
          Back to Home
        </Link>
      </div>
    </>
  );
}
